import type { GetCareCreditPersonIO } from '../types';
import { useCareCreditIntegrationV1Queries } from './use-care-credit-integration-v1-queries';
import {
  type UseCareCreditIntegrationV1QueryEndpointArgs,
  useCareCreditIntegrationV1Query,
} from './use-care-credit-integration-v1-query';

/**
 * A hook that returns a query for the `GetCareCreditPerson` endpoint.
 * @param request The request object to pass to the query.
 * @param options (optional) The options to pass to `useQuery`.
 * @param httpOptions (optional) The http options to pass to the schema function.
 * @param fallbackDataOnError (optional) The fallback data to use when an error occurs. This will not be persisted to the cache.
 * @param requestKeysToOmitFromQueryKey (optional) - An array of keys to omit from the query key. This is useful for cases where the request object contains keys that cause issues
 * when included in the query key, such as the current timestamp.
 */
export const useGetCareCreditPersonQuery = <E = unknown, D = GetCareCreditPersonIO['output']>(
  args: UseCareCreditIntegrationV1QueryEndpointArgs<'GetCareCreditPerson', E, D>
) =>
  useCareCreditIntegrationV1Query({
    endpointName: 'GetCareCreditPerson',
    ...args,
  });

export const useGetCareCreditPersonQueries = <E = unknown, D = GetCareCreditPersonIO['output']>(
  argsArr: UseCareCreditIntegrationV1QueryEndpointArgs<'GetCareCreditPerson', E, D>[]
) =>
  useCareCreditIntegrationV1Queries(
    argsArr.map((args) => ({
      endpointName: 'GetCareCreditPerson',
      ...args,
    }))
  );
